import React from "react";
import JSZip from 'jszip';
import { useState, useEffect, useMemo} from "react";
import { DataGrid, getGridNumericOperators, getGridDateOperators  } from '@mui/x-data-grid';
import Rating from '@mui/material/Rating';
import Box from '@mui/material/Box';
import { TextField } from '@mui/material';
import "./styles/ListarContenido.css";
import { Link } from 'react-router-dom';
import { FaStar, FaStarHalfAlt, FaRegStar } from "react-icons/fa";
import { esES } from '@mui/x-data-grid/locales';
import {Dialog,DialogTitle, DialogContent, DialogActions, Button, Typography, Divider, Grid} from '@mui/material';
import { IoDocumentOutline } from "react-icons/io5";
import { FaVideo, FaFolder, FaImage, FaFileAudio, FaFile, FaTag } from "react-icons/fa";
import { SiGoogleclassroom } from "react-icons/si";
import SubirContenido from "./SubirContenido";
import { useSWRConfig } from "swr";
import Swal from 'sweetalert2';


const ProductoRenderer = ({ producto }) => {
    return(
        <div style={{ display: "flex", alignItems: "center" }}>
            <img src={`data:image/png;base64,${producto.ImagenPortada}`} alt={producto.Nombre} style={{ width: "50px", height: "50px", marginRight: "10px" }} />
            <span>  {producto.Nombre}</span>
        </div>
    );
};

const ValoracionRenderer = ({ rating }) => {
    return (
        <div className="valoracion">
            {Array.from({length: 5}, (_, index) =>{
                const entero = Math.floor(rating);
                const decimal = rating - entero
                if(index < entero) {
                    return <FaStar key={index} />;
                }
                else if (index === entero && decimal >= 0.5){
                    return <FaStarHalfAlt key={index} />;
                }
                else{
                    return <FaRegStar key={index} />;
                }
            })}
        </div>
    )
}

const AccionRenderer = ({producto, verDetalles, solicitarEliminarProducto, manejarClickModificar}) => {
    return (
        <div style={{display: 'flex', gap: '10px', justifyContent: 'center', alignItems: 'center'}}>
            
            <button className="botonTabla1" onClick={() => verDetalles(producto)}>
                Ver
            </button>
            
            
            <button className="botonTabla2" onClick={() => manejarClickModificar(producto)}>
                Modificar
            </button>
            
           
            <button className="botonTabla3" onClick={() => solicitarEliminarProducto(producto)}>
                Eliminar
            </button>
        </div>
    )
}

const SesionesRenderer = ({producto}) => {
    const tipo = producto.tipo;
    return(
        tipo === "curso" ? <span></span> : <Link to={{ pathname: `/listarSesiones/${producto._id}`, state: { clase: producto }}}><button className="botonTabla">Ver sesiones</button></Link>
    )
}

const compararNombre = (v1, v2) => {
    const nombre1 = v1.toString();
    const nombre2 = v2.toString();
    return nombre1 > nombre2 ? 1 : nombre1 < nombre2 ? -1 : 0;
};

const compararTipo = (v1, v2) => {
    const tipo1 = v1.toString();
    const tipo2 = v2.toString();
    return tipo1 > tipo2 ? 1 : tipo1 < tipo2 ? -1 : 0;
};


const compararFecha = (v1, v2) => new Date(v1) - new Date(v2);

const compararValoracion = (v1, v2) => {
    const valor1 = parseFloat(v1);
    const valor2 = parseFloat(v2);
    return valor1 - valor2;
}

//Filtrado
//Filtrar rating
function ValorRatingIntroducido(props) {
    const { item, applyValue, focusElementRef } = props;
      
    const ratingRef = React.useRef(null);
    React.useImperativeHandle(focusElementRef, () => ({
      focus: () => {
        ratingRef.current
          .querySelector(`input[value="${Number(item.value) || ''}"]`)
          .focus();
      },
    }));

    const handleFilterChange = (event, newValue) => {
        applyValue({ ...item, value: newValue });
    };
    
      return (
        <Box
            sx={{
                display: 'inline-flex',
                flexDirection: 'row',
                alignItems: 'center',
                height: 48,
                pl: '20px',
            }}
        >
          <Rating
            name="custom-rating-filter-operator"
            value={Number(item.value)}
            onChange={handleFilterChange}
            precision={0.5}
            ref={ratingRef}
          />
        </Box>
      );
}

//Filtrar Fecha
function ValorFechaIntroducido(props) {
    const { item, applyValue, focusElementRef } = props;

    // Estado para la fecha
    const [fecha, setFecha] = useState(
        item.value
          ? new Date(item.value).toISOString().split('T')[0]  // Convierte el Date a "YYYY-MM-DD"
          : ''
      );
      const dateRef = React.useRef(null);

    React.useImperativeHandle(focusElementRef, () => ({
        focus: () => {
            if (dateRef.current) {
                dateRef.current.focus();
            }
        },
    }));

    const handleFilterChange = (event) => {
        const newValue = event.target.value; // Viene en "YYYY-MM-DD"
        setFecha(newValue);
        if (newValue === '') {
          applyValue({ ...item, value: null });
        } else {
          const dateObj = new Date(newValue);
          if (!isNaN(dateObj)) {
            applyValue({ ...item, value: dateObj }); // Se envía el objeto Date
          } else {
            applyValue({ ...item, value: null });
          }
        }
    };
    
    return (
    <Box
        sx={{
            display: 'inline-flex',
            flexDirection: 'row',
            alignItems: 'center',
            height: 48,
            pl: '20px',
        }}
        >
        
        <TextField
            label="Fecha"
            type="date"
            value={fecha}
            onChange={handleFilterChange}
            inputRef={dateRef}
            InputLabelProps={{
                shrink: true,
            }}
        />
    </Box>
    );
}

//Grid tabla componente
const GridTabla = ({ contenido, verDetalles, solicitarEliminarProducto, manejarClickModificar }) => {
    
    //La información que se mostrará en filas está en contenido
    //Columnas
    const columns = useMemo(() => [
        {
            field: "productos",
            headerName: "Producto",
            width: 380,
            renderCell: (params) => {
                const producto = params.row;
                return <ProductoRenderer producto={producto} />; 
            },
            valueGetter: (value, row) => row.Nombre,
            sortComparator: compararNombre, 
            sortable: true,   
            filterable: true, 
        },
        {   
            field: "Fecha",
            headerName: "Fecha de publicación",
            width: 180,
            renderCell: (params) => {
                const rawFecha = params.row.FechaSubida;
                const fecha = new Date(rawFecha);
                if (isNaN(fecha)) return "Fecha inválida";
                return fecha.toLocaleDateString("es-ES", {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric"
                }).replace(/\//g, "-");
            },
            valueGetter: (value, row) => new Date(row.FechaSubida),
            sortComparator: compararFecha,
            sortable: true,   
            filterable: true,
            filterOperators: getGridDateOperators()
                .filter((operator) => operator.value !== 'isAnyOf')
                .map((operator) => ({
                    ...operator,
                    InputComponent: operator.InputComponent
                        ? ValorFechaIntroducido
                        : undefined,
                })),
        },
        {
            field: "resennas",
            headerName: "Valoración media",
            width: 170,
            renderCell: (params) => {
                const rating = params.row.rating;
                return <ValoracionRenderer rating={rating} /> 
            },
            valueGetter: (value, row) => row.rating,
            sortComparator: compararValoracion,
            sortable: true,   
            filterable: true, 
            filterOperators: getGridNumericOperators()
                .filter((operator) => operator.value !== 'isAnyOf')
                .map((operator) => ({
                    ...operator,
                    InputComponent: operator.InputComponent
                        ? ValorRatingIntroducido
                        : undefined,
                })),
        },
        {
            field: "Tipo",
            headerName: "Tipo",
            width: 170,
            renderCell: (params) => {
                const tipo = params.row.tipo;
                if(tipo === "curso") return <span>Curso</span>;
                else if(tipo === "claseParticular") return <span>Clase particular</span>;
                else return <span>Clase</span>
            },
            valueGetter: (value, row) => row.tipo,
            sortComparator: compararTipo, 
            sortable: true,   
            filterable: true, 
        },
        {
            field: "Accion",
            headerName: "Accion",
            width: 360,
            renderCell: (params) => <AccionRenderer producto={params.row} verDetalles={verDetalles} solicitarEliminarProducto={solicitarEliminarProducto} manejarClickModificar={manejarClickModificar} />,
            sortable: false,   
            filterable: false, 
        },
        {
            field: "sesiones",
            headerName: "Sesiones",
            width: 150,
            renderCell: (params) => {
                const producto = params.row;
                return <SesionesRenderer producto={producto} /> 
            },
            sortable: false,   
            filterable: false, 
        },
    ]);

    return (
        <div className="gridContainer">
            <DataGrid 
                rows={contenido}
                columns={columns.map(col => ({
                    ...col,
                    headerAlign: 'center', // Centra el encabezado de la columna
                    align: 'center', // Centra el contenido de la celda
                }))}                
                pageSize={20}
                rowsPerPageOptions={[20]}
                disableSelectionOnClick
                getRowId={(row) => row._id}
                sx={{
                    borderColor: 'var(--text-principal)',
                    color: 'var(--text-principal)', 
                    fontSize: "14px",
                    '& .MuiDataGrid-columnHeaders': {
                      backgroundColor: '#fff',
                      color: 'black',
                      fontWeight: 'bold',
                      borderBottom: '0.25px solid var(--text-principal)'
                    },
                    "& .MuiTablePagination-displayedRows": {
                        color: "#fff", 
                    },
                    "& .MuiDataGrid-footerContainer": {
                        color: 'var(--text-principal)', 
                        fontWeight: "bold",
                    },
                    '& .MuiSvgIcon-root': {
                        color: 'black', // Cambia el color de los íconos en general (como la flecha de ordenación y los tres puntos)
                    },
                    '& .MuiDataGrid-sortIcon': {
                        color: 'black', // Cambia el color de la flecha de ordenación
                    },
                    '& .MuiDataGrid-menuIconButton svg': {
                        color: 'black', // Cambia el color del ícono del menú de la columna (los tres puntos)
                    },
                    // 'Filas por página:' texto
                    "& .MuiTablePagination-selectLabel": {
                        color: 'var(--text-principal)',
                    },
                    // Selector desplegable (100)
                    "& .MuiInputBase-root": {
                       color: "var(--text-principal)",
                    },
                
                    // Opciones del selector al abrirse
                    "& .MuiMenuItem-root": {
                        color: "black", // texto de los items cuando se despliega el select
                    },
                
                    // '1–7 de 7'
                    "& .MuiTablePagination-displayedRows": {
                        color: "var(--text-principal)",
                    },
                
                    // Flechas de navegación
                    "& .MuiSvgIcon-root": {
                        color: "var(--text-principal)",
                    },
                    '& .MuiDataGrid-row': {
                        borderBottom: '0.25px solid var(--text-principal)', 
                    },
                    // Borde del selector si quieres quitarlo o estilizarlo
                    "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#fff",
                    },
                
                    // Icono del desplegable (flecha abajo del select)
                    "& .MuiSelect-icon": {
                        color: "var(--text-principal)",
                    },
                    // Icono menú cabecera
                    "& .MuiDataGrid-columnHeaderMenuIcon": {
                        color: "black",
                    },
                }}
                localeText={{
                    ...esES.components.MuiDataGrid.defaultProps.localeText,
                    rowsPerPage: "Filas por página:",
                }}
                
            />
        </div>
    );
};

const ListarContenido = () => {
    const { mutate } = useSWRConfig();

    const [usuario] = useState(() => {
        const usuarioAlmacenado = localStorage.getItem("userLogueado");
        return usuarioAlmacenado ? JSON.parse(usuarioAlmacenado) : null;
    });

    const [contenido, setContenido] = useState([]);

    //Carga de la página
    const [loading, setLoading] = useState(true);

    //Estado para controlar si se muestra formulario de modificación o no
    const [mostrarFormularioEdicion, setMostrarFormularioEdicion] = useState(false);

    //Estado para saber si se está editando o no al abrir el formulario
    const [editando, setEditando] = useState(false);

    //Datos a editar
    const [datosAEditar, setDatosAEditar] = useState(null);


    const [seleccion, setSeleccion] = useState(null); //Seleccionar producto
    const [abiertoDetalle, setAbiertoDetalle] = useState(false);  //Abrir modal
    const [confirmarEliminacion, setconfirmarEliminacion] = useState(false); //Abrir modal de eliminacion
    
    // getIcono para renderizar el icono correcto
    const getIcono = (archivo) => {
        if (archivo.isDirectory) return <FaFolder />;
        switch (archivo.tipo) {
            case 'Documento': return <IoDocumentOutline />;
            case 'Video':     return <FaVideo />;
            case 'Audio':     return <FaFileAudio />;
            case 'Foto':      return <FaImage />;
            default:          return <FaFile />;
        }
    };

    let baseUrl;
    if(process.env.NODE_ENV === 'development') baseUrl = 'http://localhost:8080';
    else baseUrl='https://app-formacion.vercel.app';

    useEffect(() => {
        const fetchProductosTutor = async () => {
            setLoading(true);
            try{
                
                //Realizar las 2 peticiones en paralelo
                const endpoints = [
                    {url: `${baseUrl}/api/clases/search/tutor/${usuario._id}`, collection: 'clases' },
                    {url: `${baseUrl}/api/cursos/search/tutor/${usuario._id}`, collection: 'cursos'},
                ];

                // Función auxiliar para obtener los datos y añadir el atributo "tipo" según la colección
                const fetchWithTipo = async ({ url, collection }) => {
                    const response = await fetch(url);
                    const data = await response.json();
                    if (Array.isArray(data)) {
                        if (collection === 'cursos') {
                            return data.map(item => ({ ...item, tipo: 'curso' }));
                        } else if (collection === 'clases') {
                            return data.map(item => ({
                                ...item,
                                tipo: item.Particular ? 'claseParticular' : 'clase'
                            }));
                        }
                    }
                    return [];
                };

                const resultados = await Promise.all(endpoints.map(endpoint => fetchWithTipo(endpoint)));
                const productosTutor = resultados.flat();
                
                //Añadir a cada producto su valoración media y al tutor
                const prodCompletos = await Promise.all(
                    productosTutor.map(async (prod) => {
                        let prodRating = 0;
                        let numResennas = 0;
                        try{
                            const resValoracion = await fetch(
                                `${baseUrl}/api/resennas/search/contenido/${prod._id}`,
                                {
                                    method: "GET",
                                    headers: { "Content-Type": "application/json" }, 
                                }
                            );
                            if(resValoracion.ok){
                                const resennas = await resValoracion.json();
                                numResennas = resennas.length;
                                const suma = resennas.reduce(
                                    (acum, r) => acum + r.Valoracion,
                                    0
                                );
                                //Calcular valor medio de reseñas
                                prodRating = resennas.length > 0 ? suma / resennas.length : 0;
                            }
                        } catch(error){
                            console.error("Error al obtener reseñas: " + error.message);
                        }
                        let numVentas = 0;
                        try {
                            const resV = await fetch(
                            `${baseUrl}/api/compras/search/contenido/${prod._id}`,
                                { headers: { 'Content-Type': 'application/json' } });
                            if (resV.ok) {
                                const compras = await resV.json();
                                numVentas = compras.length;
                            }
                        } catch (e) {
                            console.error('Error al obtener compras:', e);
                        }
                            //Devolver el producto con toda la información extra de tutor y valoracion
                            return { ...prod, tutor: usuario, rating: prodRating, numResennas: numResennas, numVentas: numVentas };
                        })
                    );


                setContenido(prodCompletos);
            } catch (error){
                console.error("Error al obtener los productos del tutor", error);
            } finally{
                setLoading(false);
            }
        };

        fetchProductosTutor();
    }, [usuario._id]);

    const [archivos, setArchivos] = useState([]);
    const [sesiones, setSesiones] = useState([]);

    useEffect(() => {
        if (!seleccion) return;

        if (seleccion.tipo === 'curso' && seleccion.Archivos) {
        const data = typeof seleccion.Archivos === 'string' ? Uint8Array.from(atob(seleccion.Archivos), c => c.charCodeAt(0)).buffer : seleccion.Archivos;

        const zip = new JSZip();
        zip.loadAsync(data).then((z) => {
            const lista = [];
            z.forEach((relativePath, zipEntry) => {
                // extraer extensión
                const partes = relativePath.split('.');
                const ext = partes.length > 1
                    ? partes.pop().toLowerCase()
                    : '';

                // inferir tipo
                let tipo = 'Desconocido';
                if (['pdf','doc','docx','xls','xlsx','ppt','pptx','txt','odt'].includes(ext)) {
                    tipo = 'Documento';
                } else if (['mp4','avi','mkv','mov','wmv'].includes(ext)) {
                    tipo = 'Video';
                } else if (['mp3','wav','aac','flac'].includes(ext)) {
                    tipo = 'Audio';
                } else if (['jpg','jpeg','png','gif','bmp','webp'].includes(ext)) {
                    tipo = 'Foto';
                }
                lista.push({
                    nombre: relativePath,
                    isDirectory: zipEntry.dir,
                    tamaño: zipEntry._data.uncompressedSize,
                    tipo,
                });
            });
            setArchivos(lista);
        }).catch(console.error);
        }

        if (seleccion.tipo !== 'curso' && Array.isArray(seleccion.Id_Sesion)) {
        Promise.all(seleccion.Id_Sesion.map(id => fetch(`${baseUrl}/api/sesiones/${id}`).then(r => r.json()))).then(setSesiones).catch(console.error);
        }
    }, [seleccion]);

    //Ver detalles del producto
    const manejarvistaDetalles = (producto) => {
        setSeleccion(producto);
        setAbiertoDetalle(true);
    }

    //Edición de contenido
    //Al pulsar modificar se abre el formulario
    const manejarClickModificar = (producto) => {
        setDatosAEditar(producto);
        setEditando(true);
        setMostrarFormularioEdicion(true);
    }

    //Cerrar/ocultar el formulario y limpiar
    const cerrarFormulario = () => {
        setMostrarFormularioEdicion(false);
        setEditando(false);
        setDatosAEditar(null);
    }

    //Eliminación del contenido
    //Mostrar dialogo de eliminación
    const solicitarEliminarProducto = (producto) => {
        setAbiertoDetalle(false);
        setSeleccion(producto);
        setconfirmarEliminacion(true);
    }

    //Eliminación del producto
    const manejarEliminacionProducto = async() => {
        try{
            let url = '';
            if(seleccion.tipo === 'curso') url = `${baseUrl}/api/cursos/${seleccion._id}`
            else url = `${baseUrl}/api/clases/${seleccion._id}`
            
            const resp = await fetch(url, {
                method: 'DELETE',
                headers: { 'Content-Type': 'application/json' },
            });

            if (!resp.ok) {
                const err = await resp.json();
                throw new Error(err.message || `HTTP ${resp.status}`);
            }

            //Actualizar el estado local filtrando el eliminado
            setContenido(prev =>
                prev.map(item =>
                    item._id === seleccion._id
                    ? {
                        ...item,
                        Nombre: null,
                        Tematica: null,
                        Descripcion: null,
                        ImagenPortada: null,
                        FechaSubida: null,
                    }
                    : item
                )
            );
            await mutate([
                `${baseUrl}/api/cursos/`,
                `${baseUrl}/api/clases/`
            ]);
            await mutate(`${baseUrl}/api/productos/${seleccion._id}`);
            await mutate(`${baseUrl}/api/compras/search/usuario/${usuario?._id}`);
            await mutate(`${baseUrl}/api/compras/${seleccion._id}`);
            await mutate(`${baseUrl}/api/users/tutor/${seleccion._id}`);
            Swal.fire({
                icon: 'success',
                title: '¡Producto eliminado!',
                text: `El producto "${seleccion.Nombre}" se ha eliminado correctamente.`,
                confirmButtonText: 'Aceptar'
            });
        
        } catch(error){
            console.error('Error al eliminar producto:', error);
            Swal.fire({
                icon: 'error',
                title: 'Error en el servidor',
                text: 'Se ha producido un error al eliminar el producto',
                confirmButtonText: 'Aceptar'
            });
        }
        finally{
            setconfirmarEliminacion(false);
            setSeleccion(null);
        }
    }

    //Cierre del dialogo de ver detalles
    const manejarCierre = () => {
        setAbiertoDetalle(false);
        setSeleccion(null);
    }
       
    return(
        <div className="principal">
            <h1>Contenido Subido</h1>   
            <div className="containerContenido">
                {loading ? (
                    <div className="noContenido">
                        <p>Cargando contenido...</p>
                    </div>
                ) : contenido.filter(item => item.Nombre !== null && item.Descripcion !== null && item.FechaSubida !== null && item.ImagenPortada !== null && item.Tematica !== null).length === 0 ? (
                    <div className="noContenido">
                        <p>Aún no ha subido ningún contenido</p>
                    </div>
                ) : (
                    <GridTabla 
                        contenido={contenido.filter(item => 
                            item.Nombre !== null &&
                            item.Descripcion !== null &&
                            item.Tematica !== null &&
                            item.ImagenPortada !== null &&
                            item.FechaSubida !== null
                        )} 
                        verDetalles={manejarvistaDetalles} 
                        solicitarEliminarProducto={solicitarEliminarProducto}
                        manejarClickModificar={manejarClickModificar}
                    />
                )}
            </div>

            {/*Modal para ver detalles*/}
            <Dialog open={abiertoDetalle} onClose={manejarCierre} fullWidth maxWidth="md">
                <DialogTitle>{`${seleccion?.Nombre || ""}`}</DialogTitle>
                <DialogContent dividers sx={{maxHeight: '70vh',overflowY: 'auto',}}>
                    {seleccion && (
                        <>
                            <div className="cabeceraModal"> 
                                <div className="imagenModal">
                                    <img src={`data:image/png;base64,${seleccion.ImagenPortada}`} alt={seleccion.Nombre} style={{ width: "80px", height: "80px", marginRight: "10px" }} />
                                </div> 
                                <div>
                                    <Typography gutterBottom variant="h5">{seleccion.Nombre}</Typography>
                                    <Typography gutterBottom color="text.secondary">Tipo: {seleccion.tipo === 'clase' ? 'Clase' : (seleccion.tipo === 'curso' ? 'Curso' : 'Clase Particular')}</Typography>
                                    <Typography gutterBottom><strong>Descripcion: </strong>{seleccion.Descripcion}</Typography>
                                    <Typography gutterBottom><strong>Precio: </strong>{(seleccion.Precio).toFixed(2)} €</Typography>
                                </div>
                            </div>

                        <Divider sx={{my: 2}}/>

                        <Grid container spacing={2}>
                            <Grid item xs={12} md={6}>
                                <Typography gutterBottom><strong>Temáticas: </strong> {seleccion.Tematica.join(", ").toString()}</Typography>
                                <Typography gutterBottom>
                                    <strong>Fecha de publicación: </strong>{new Date (seleccion.FechaSubida).toLocaleDateString("es-ES", {
                                        day: "2-digit",
                                        month: "2-digit",
                                        year: "numeric"
                                    }).replace(/\//g, "-")}
                                </Typography>

                                {seleccion.tipo === 'curso' ? (
                                    <Typography gutterBottom> <strong>Duración: </strong> {seleccion.Duracion} minutos </Typography>
                                ) : (
                                <>
                                    <Typography gutterBottom>
                                        <strong>Fecha de Inicio: </strong>
                                        {new Date (seleccion.FechaInicio).toLocaleDateString("es-ES", {
                                            day: "2-digit",
                                            month: "2-digit",
                                            year: "numeric"
                                        }).replace(/\//g, "-")} 
                                    </Typography>

                                    <Typography gutterBottom>
                                        <strong>Fecha de finalización: </strong>
                                        {new Date (seleccion.FechaFin).toLocaleDateString("es-ES", {
                                            day: "2-digit",
                                            month: "2-digit",
                                            year: "numeric"
                                        }).replace(/\//g, "-")}
                                    </Typography>

                                    <Typography gutterBottom>
                                        <strong>Particular: </strong> {seleccion.Particular ? 'Sí' : 'No' } 
                                    </Typography>

                                    <Typography gutterBottom>
                                        <strong>Nº plazas: </strong> {seleccion.Plazas}
                                    </Typography>
                                </>
                                )}
                            </Grid>
                            
                            <Grid item xs={12} md={6}>
                                <Typography gutterBottom component="div">
                                    <strong>Valoración media:</strong>
                                    <div className="modalValoracion">
                                        {Array.from({length: 5}, (_, index) =>{
                                            const entero = Math.floor(seleccion.rating);
                                            const decimal = seleccion.rating - entero
                                            if(index < entero) {
                                                return <FaStar key={index} />;
                                            }
                                            else if (index === entero && decimal >= 0.5){
                                                return <FaStarHalfAlt key={index} />;
                                            }
                                            else{
                                                return <FaRegStar key={index} />;
                                            }
                                        })}
                                    </div>
                                </Typography>

                                <Typography gutterBottom><strong>Nº de reseñas del producto: </strong>{seleccion.numResennas}</Typography>
                                <Typography gutterBottom><strong>Nº de ventas del producto: </strong>{seleccion.numVentas}</Typography>
                            </Grid>
                        </Grid>

                        <Divider sx={{ my: 2 }} />

                        {seleccion.tipo === 'curso' && archivos.length > 0 && (
                        <div>
                            <Typography variant="h6" gutterBottom>Contenido del curso</Typography>
                            <ul className="listaFicheros">
                                {archivos
                                    .filter(a => a.isDirectory)
                                    .map(directorio => (
                                        <li key={directorio.nombre} className="listaFicheros_dir">
                                            <Typography component="div" gutterBottom>
                                                <strong>
                                                    {getIcono(directorio)}{' '}
                                                    {directorio.nombre.replace(/\/$/, '')}
                                                </strong>
                                            </Typography>
                                            <ul className="listaFicheros_sub">
                                                {archivos
                                                    .filter(a => !a.isDirectory && a.nombre.startsWith(directorio.nombre))
                                                    .map(archivo => (
                                                    <li key={archivo.nombre}>
                                                        <Typography component="div">
                                                            {getIcono(archivo)}{' '}
                                                            {archivo.nombre.replace(directorio.nombre, '')} —{' '}
                                                            Tamaño: {archivo.tamaño} KB
                                                        </Typography>
                                                    </li>
                                                ))}
                                            </ul>
                                        </li>
                                    ))}

                                    {archivos
                                        .filter(a => !a.isDirectory && !a.nombre.includes('/'))
                                        .map(archivo => (
                                            <li key={archivo.nombre}>
                                                <Typography component="div">
                                                    {getIcono(archivo)} {archivo.nombre} — Tamaño: {archivo.tamaño} KB
                                                </Typography>
                                            </li>
                                        ))}
                                </ul>
                            </div>
                            )}

                            {seleccion.tipo !== 'curso' && sesiones.length > 0 && (
                            <div>
                                <Typography variant="h6" gutterBottom>Sesiones de la clase</Typography>
                                <ul className="listaSesion">
                                    {sesiones.map((sesion, i) => (
                                        <li key={i}>
                                            <Typography gutterBottom>
                                                <SiGoogleclassroom />{' '}
                                                {sesion.Parte}. {sesion.Nombre} — Fecha:{' '}
                                                {(() => {
                                                    const fecha = new Date(sesion.Fecha);
                                                    const fechaStr = fecha.toLocaleDateString("es-ES", {
                                                        day: "2-digit",
                                                        month: "2-digit",
                                                        year: "numeric"
                                                    }).replace(/\//g, "-");
                                                    const horaStr = fecha.toLocaleTimeString("es-ES", {
                                                        hour: "2-digit",
                                                        minute: "2-digit"
                                                    });
                                                    return `${fechaStr} a las ${horaStr}`;
                                                })()} — Duración:{' '}{sesion.Duracion} minutos
                                            </Typography>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                            )}
                        </>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button sx={{ 
                               textTransform: 'none',
                                '& .MuiButton-label': {
                                    textTransform: 'lowercase',         
                                    '&::first-letter': {
                                        textTransform: 'uppercase'        
                                    }
                                }
                            }} onClick={manejarCierre}>Cerrar</Button>
                </DialogActions>
            </Dialog>

            {/*Modal para eliminar reseña */}
            <Dialog
                open={confirmarEliminacion}
                onClose={() => setconfirmarEliminacion(false)}
                fullWidth
                maxWidth="md"
            >
                <DialogTitle>
                    {`Eliminar ${seleccion?.Nombre}`}
                </DialogTitle>
                <DialogContent>
                    <Typography>
                        {seleccion?.tipo === 'curso' ? (
                            <>
                                ¿Estás seguro de que deseas eliminar <strong>{seleccion?.Nombre}</strong>? Después no podrá deshacer el cambio.
                            </>
                        ) : (
                            <>
                                ¿Estás seguro de que deseas eliminar <strong>{seleccion?.Nombre}</strong> y todas sus sesiones asociadas? Después no podrá deshacer el cambio.
                            </>
                        )}
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button sx={{ 
                        textTransform: 'none',
                        '& .MuiButton-label': {
                            textTransform: 'lowercase',         
                            '&::first-letter': {
                                textTransform: 'uppercase'        
                            }
                        }
                    }} onClick={() => setconfirmarEliminacion(false)}>No</Button>
                    <Button sx={{ 
                               textTransform: 'none',
                                '& .MuiButton-label': {
                                    textTransform: 'lowercase',         
                                    '&::first-letter': {
                                        textTransform: 'uppercase'        
                                    }
                                }
                            }} color="error" onClick={manejarEliminacionProducto}>
                        Sí, eliminar
                    </Button>
                </DialogActions>
            </Dialog>
            
            <Dialog open={mostrarFormularioEdicion} maxWidth="lg" fullWidth PaperProps={{sx: {m: 0, borderRadius: 0, boxShadow: 'none'}}} BackdropProps={{sx: {backgroundColor: 'rgba(0,0,0,0.5)'}}}>
                <DialogActions sx={{justifyContent: "space-between", p: 1}}>
                    <Button onClick={cerrarFormulario}>X</Button>
                </DialogActions>
                <DialogContent sx={{ p: 0, height: "100%"}}>
                    <SubirContenido 
                        editando={editando}
                        datosIniciales={datosAEditar}
                        onClose={cerrarFormulario}
                        onSuccess={(productoActualizado) => {
                            productoActualizado.rating      = datosAEditar.rating      ?? 0;
                            productoActualizado.numResennas = datosAEditar.numResennas ?? 0;
                            productoActualizado.numVentas   = datosAEditar.numVentas   ?? 0;
                            productoActualizado.tipo = datosAEditar.tipo;

                            setContenido(prev => prev.map(item => item._id === productoActualizado._id ? productoActualizado : item));
                            cerrarFormulario();
                            window.location.reload();
                        }}
                    />
                </DialogContent>
            </Dialog>
        </div> 
    );
};


export default ListarContenido;